// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/delete_uncategorized_images.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/delete_uncategorized_images.proto.
 */
export const file_vision_assets_v1_delete_uncategorized_images: GenFile = /*@__PURE__*/
  fileDesc("CjJ2aXNpb24vYXNzZXRzL3YxL2RlbGV0ZV91bmNhdGVnb3JpemVkX2ltYWdlcy5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEikgEKIERlbGV0ZVVuY2F0ZWdvcml6ZWRJbWFnZXNSZXF1ZXN0ElAKBnBhcmFtcxgBIAEoCzJALnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkRlbGV0ZVVuY2F0ZWdvcml6ZWRJbWFnZXNSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSKAAQohRGVsZXRlVW5jYXRlZ29yaXplZEltYWdlc1Jlc3BvbnNlElEKBnJlc3VsdBgBIAEoCzJBLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkRlbGV0ZVVuY2F0ZWdvcml6ZWRJbWFnZXNSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.assets.v1.DeleteUncategorizedImagesRequest
 */
export type DeleteUncategorizedImagesRequest = Message<"protos.vision.assets.v1.DeleteUncategorizedImagesRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteUncategorizedImagesRequest.Params params = 1;
   */
  params?: DeleteUncategorizedImagesRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteUncategorizedImagesRequest.
 * Use `create(DeleteUncategorizedImagesRequestSchema)` to create a new message.
 */
export const DeleteUncategorizedImagesRequestSchema: GenMessage<DeleteUncategorizedImagesRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_uncategorized_images, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteUncategorizedImagesRequest.Params
 */
export type DeleteUncategorizedImagesRequest_Params = Message<"protos.vision.assets.v1.DeleteUncategorizedImagesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteUncategorizedImagesRequest.Params.
 * Use `create(DeleteUncategorizedImagesRequest_ParamsSchema)` to create a new message.
 */
export const DeleteUncategorizedImagesRequest_ParamsSchema: GenMessage<DeleteUncategorizedImagesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_uncategorized_images, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteUncategorizedImagesResponse
 */
export type DeleteUncategorizedImagesResponse = Message<"protos.vision.assets.v1.DeleteUncategorizedImagesResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteUncategorizedImagesResponse.Result result = 1;
   */
  result?: DeleteUncategorizedImagesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteUncategorizedImagesResponse.
 * Use `create(DeleteUncategorizedImagesResponseSchema)` to create a new message.
 */
export const DeleteUncategorizedImagesResponseSchema: GenMessage<DeleteUncategorizedImagesResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_uncategorized_images, 1);

/**
 * @generated from message protos.vision.assets.v1.DeleteUncategorizedImagesResponse.Result
 */
export type DeleteUncategorizedImagesResponse_Result = Message<"protos.vision.assets.v1.DeleteUncategorizedImagesResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.DeleteUncategorizedImagesResponse.Result.
 * Use `create(DeleteUncategorizedImagesResponse_ResultSchema)` to create a new message.
 */
export const DeleteUncategorizedImagesResponse_ResultSchema: GenMessage<DeleteUncategorizedImagesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_uncategorized_images, 1, 0);

